<template>
  <div class="tw:flex tw:items-center tw:gap-4 tw:text-zinc-400">
    <component :is="icon" stroke-width="1" class="tw:size-12 tw:flex-none" />
    <span class="tw:text-sm">{{ label }}</span>
  </div>
</template>

<script setup>
/**
 * A booking step that has not been filled in yet.
 *
 * Deliberately quiet rather than a warning: nothing is wrong, the step is simply still to do, and
 * a form that opens on three yellow boxes reads as broken. The icon keeps the same 48px footprint
 * as the filled state so the rows do not jump as the user works through them.
 */
defineProps({
  label: {
    type: String,
    required: true
  },
  icon: {
    type: [Object, Function],
    required: true
  }
});
</script>
